<nav class="navbar navbar-expand-lg navbar-light bg-faded pt-0 pb-0">
  <div class="container-fluid p-0">
    <div class="navbar-header">
      <button
        type="button"
        class="navbar-toggle d-lg-none float-left"
        data-toggle="collapse"
      >
        <span class="sr-only">{{ "Toggle navigation" | translate }}</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>
    <div class="navbar-container">
      <div
        *ngIf="carregarDados()"
        class="collapse navbar-collapse my-3"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav m-0">
          <li
            *ngIf="exibirContas()"
            (click)="carregarContas()"
            class="nav-item"
            ngbDropdown
            placement="bottom-right"
            [autoClose]="'outside'"
          >
            <a class="nav-link novoLayout">
              <span class="line-height-1" id="dropdownBasic2" ngbDropdownToggle>
                <i class="centericon centericon-database m-0"></i>
                <p class="d-none">{{ "Contas" | translate }}</p>
                <span
                  *ngIf="tenantService.getNomeTenantStorage()"
                  class="csnome"
                  >{{ tenantService.getNomeTenantStorage() }}</span
                >
              </span>
              <button
                type="button"
                class="sairConta"
                [title]="'Sair da conta' | translate"
                (click)="sairDaConta()"
                *ngIf="isIntegrador() && exibirNomeConta()"
              >
                <i class="centericon centericon-limpar_solicitante m-0"></i>
              </button>
            </a>
            <div
              *ngIf="isIntegrador() || exibirSelectConta()"
              ngbDropdownMenu
              aria-labelledby="dropdownBasic2"
              class="novoLayout sub-itens"
            >
              <input
                (keyup)="carregarContas()"
                [(ngModel)]="filter.str1"
                [placeholder]="'Digite o nome da conta...' | translate"
                type="text"
                class="dropdown-item"
              />
              <div *ngFor="let conta of contas">
                <h4 class="dropdown-divider m-0"></h4>
                <button (click)="entrarNaConta(conta)" class="dropdown-item">
                  <i class="centericon centericon-selecionar_conta"></i>
                  <span class="">{{ conta.nomeConta }}</span>
                </button>
              </div>
            </div>
          </li>

          <li
            *ngIf="
              contasAux &&
              contasAux.length == 1 &&
              isIntegrador() &&
              exibirNomeConta()
            "
          >
            <a class="nav-link novoLayout">
              <span class="csnome">{{ contas[0].nomeConta }}</span>
              <button
                type="button"
                class="sairConta"
                [title]="'Sair da conta' | translate"
                (click)="sairDaConta()"
              >
                <i class="centericon centericon-limpar_solicitante m-0"></i>
              </button>
            </a>
          </li>

          <li class="nav-item" ngbDropdown placement="bottom-right">
            <a
              class="nav-link novoLayout"
              [ngClass]="{ 'border-navnar': exibirContas() }"
              id="dropdownBasic3"
              ngbDropdownToggle
            >
              <i class="centericon centericon-idioma m-0"></i>
            </a>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownBasic3"
              class="novoLayout sub-itens"
            >
              <button
                (click)="setUserLocale(locale)"
                class="dropdown-item"
                href="javascript:;"
                *ngFor="let locale of locales"
              >
                <span>{{ locale.description }}</span>
              </button>
            </div>
          </li>

          <li class="nav-item" ngbDropdown placement="bottom-right">
            <a
              class="nav-link border-navnar novoLayout"
              id="dropdownBasic3"
              ngbDropdownToggle
            >
              <div class="border-navnar" *ngIf="validarFotoStorage()">
                <div class="custom_foto_perfil">
                  <img [src]="getPessoaLogada()" height="30" width="30" />
                </div>
              </div>
              <i
                *ngIf="!getPessoaLogada()"
                class="centericon centericon-usuario m-0"
              ></i>
            </a>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownBasic3"
              class="novoLayout sub-itens"
            >
              <div *ngIf="nomePessoa">
                <div class="dropdown-item">
                  <i class="centericon centericon-usuario"></i>
                  <span>{{ nomePessoa }}</span>
                </div>
                <h4 class="dropdown-divider m-0"></h4>
              </div>
              <button
                class="dropdown-item"
                routerLink="/meus-dados"
                *ngIf="isIntegrador() || exibirMenuMeusDados()"
              >
                <i class="centericon centericon-meusdados_menu"></i>
                <span>{{ "Meus dados" | translate }}</span>
              </button>
              <button
                class="dropdown-item"
                href="javascript:;"
                routerLink="/configuracoes/list-configuracoes"
                *ngIf="
                  !isIntegradorOuDistribuidor() && exibirMenuConfiguracoes()
                "
              >
                <i class="centericon centericon-configuracoes"></i>
                <span>{{ "Configurações" | translate }}</span>
              </button>
              <button
                class="dropdown-item"
                routerLink="/conta/select-conta"
                *ngIf="exibirSelectConta()"
              >
                <i class="centericon centericon-selecionar_conta"></i>
                <span>{{ "Selecionar conta" | translate }}</span>
              </button>
              <button
                class="dropdown-item"
                routerLink="/alterar-senha"
                *ngIf="existeTenant() || isIntegradorOuDistribuidor()"
              >
                <i class="centericon centericon-editar"></i>
                <span>{{ "Alterar senha" | translate }}</span>
              </button>
              <div
                class="dropdown-divider m-0"
                *ngIf="existeTenant() || isIntegradorOuDistribuidor()"
              ></div>
              <button
                class="dropdown-item"
                href="javascript:;"
                (click)="logout()"
              >
                <i class="centericon centericon-sair"></i>
                <span>{{ "Sair" | translate }}</span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
